<template>
  <basic-container id="carinout2022">
    <searchForm
      ref="searchForm"
      v-show="showSearch"
      :spacelist="spacelist"
      @searchChange="searchChange"
      @searchReset="searchReset"
      :realityAccount.sync="realityAccount"
      :shouldAccount.sync="shouldAccount"
      :activeName.sync="activeName"
    ></searchForm>
    <el-tabs v-model="activeName" type="card" @tab-click="handleSwitch">
      <el-tab-pane name="intoPark">
        <span slot="label"><i class="el-icon-bottom-right"></i>入场记录</span>
      </el-tab-pane>
      <el-tab-pane name="outPark">
        <span slot="label"><i class="el-icon-top-right"></i>出场记录</span>
      </el-tab-pane>
      <el-tab-pane name="remainPark">
        <span slot="label"><i class="el-icon-s-flag"></i> 在场记录</span>
      </el-tab-pane>
    </el-tabs>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="refreshChange"
    >
      <template slot="menuRight">
        <el-tooltip class="item" effect="dark" content="搜索" placement="top-start">
          <el-button
            style="float: right"
            size="small"
            icon="el-icon-search"
            circle
            @click="openSearchBox"
          ></el-button>
        </el-tooltip>
      </template>
      <template slot-scope="scope" slot="menu">
        <el-button
          type="text"
          size="small"
          v-if="showInImageBtn"
          plain
          @click="handleImageShow(scope.row)"
          >详情
        </el-button>
        <el-button
          type="text"
          size="small"
          v-else-if="showOutImageBtn"
          plain
          @click="handleInOutImageShow(scope.row)"
          >详情
        </el-button>
        <el-button type="text" size="small" plain v-else @click="manualOutPark(scope.row)"
          >手动出场
        </el-button>
        <!-- <el-button
          type="text"
          size="small"
          plain
          v-if="scope.row.isInGroup == 1 && permissionList.parkingSpaceGroup"
          @click="openCarGroup(scope.row)"
          >查看车位组
        </el-button> -->
      </template>
      <template slot-scope="scope" slot="spaceIdSearch">
        <el-form-item prop="spaceId">
          <selectSearch  v-model="spaceId" :dicData="spacelist" @change="userDistricts"></selectSearch>
          <!-- <el-select
            v-model="spaceId"
            filterable
            placeholder="请选择车场名称"
            style="width: 100%"
            @change="userDistricts"
          >
            <el-option
              v-for="item in spacelist"
              :key="item.id"
              :label="item.title"
              :value="item.id"
            >
            </el-option>
          </el-select> -->
        </el-form-item>
      </template>
      <template slot-scope="scope" slot="dateRangeSearch">
        <!-- <el-form-item prop="dateRange"> -->
        <el-date-picker
          style="width: 100%"
          v-model="dateRange"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="到"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
        >
        </el-date-picker>
        <!-- </el-form-item> -->
      </template>
      <template slot-scope="scope" slot="payTypeSearch">
        <el-select
          v-model="payType"
          placeholder="支付方式"
          clearable="true"
          @change="onChangePayType"
        >
          <el-option
            v-for="item in payTypeList"
            :key="item.value"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </template>
      <template slot-scope="scope" slot="shouldAccountSearch">
        <el-input
          placeholder="应缴总额"
          v-model="shouldAccount"
          :disabled="true"
          style="color: red"
        >
        </el-input>
      </template>
      <template slot-scope="scope" slot="realityAccountSearch">
        <el-input placeholder="实缴总额" v-model="realityAccount" :disabled="true"> </el-input>
      </template>
      <!--  -->
      <!-- <template slot-scope="{ row }" slot="cloudCarImage_intoPark" v-if="activeName === 'intoPark'">
        <img
          style="height: 40px"
          :src="row.inPic"
          @mouseover="(e) => showImage(e, row.inPic)"
          @mouseout="hideImage"
        />
      </template> -->
      <!-- <template slot-scope="{ row }" slot="cloudCarInImage" v-if="activeName === 'outPark'">
        <img
          style="height: 40px"
          :src="row.cloudCarInImage"
          @mouseover="(e) => showImage(e, row.cloudCarInImage)"
          @mouseout="hideImage"
        />
      </template> -->
      <!-- <template slot-scope="{ row }" slot="cloudCarImage" v-if="activeName === 'outPark'">
        <img
          style="height: 40px"
          :src="row.outPic"
          @mouseover="(e) => showImage(e, row.outPic)"
          @mouseout="hideImage"
        />
      </template> -->
      <template slot="parkingTime" slot-scope="{ row }">
        <span :style="row.specialShow === 2 ? 'color:#f00' : ''">{{ row.parkingTime }}</span>
      </template>
      <template slot="parkingTimeHeader" slot-scope="{ column }">
        <caret @sort-change="sortChange">
          {{ (column || {}).label }}
        </caret>
      </template>
      <!--  -->
      <template slot="menuLeft">
        <el-button type="primary" size="small" icon="el-icon-download" @click="exportExcelNew"
          >导 出</el-button
        >
        <!-- <el-button type="primary" size="small" icon="el-icon-download" @click="openExportExcel">导 出</el-button> -->
        <exportData :moduleType="400" @exportExcel="exportExcel"></exportData>
        <el-button
          type="primary"
          size="small"
          v-if="this.activeName == 'remainPark' && permissionList.importCarRemain"
          icon="el-icon-upload2"
          @click="importCarRemainForm"
          >导入
        </el-button>
      </template>
      <template slot="chargeMoney" slot-scope="scope">
        {{ tool.money_format_allowvoid(scope.row.chargeMoney) }}
      </template>
      <template slot="payableMoney" slot-scope="scope">
        {{ tool.money_format_allowvoid(scope.row.payableMoney) }}
      </template>
    </avue-crud>
    <el-dialog
      title="在场车辆信息数据导入"
      append-to-body
      :visible.sync="showUploadDialog"
      :close-on-click-modal="false"
      width="555px"
      accept="vnd.ms-excel"
    >
      <avue-form
        v-if="showUploadDialog"
        :option="ImportExcelOption"
        ref="excelform"
        v-model="upload"
        :upload-after="uploadAfter"
        :before-upload="beforeUpload"
      >
        <template slot-scope="scope" slot="downloadAction">
          模板下载:
          <el-button type="primary" size="small" icon="el-icon-plus" @click="exportDemoExcel"
            >下载模板
          </el-button>
          <!-- <el-button @click="tip">自定义按钮</el-button> -->
        </template>
      </avue-form>
    </el-dialog>
    <el-dialog
      title="按条件导出"
      append-to-body
      :visible.sync="exportExcelFlag"
      @closed="closeDialog"
    >
      <avue-form
        v-model="exportExcelForm"
        ref="exportExcelFormRef"
        :option="exportExcelOption"
        @submit="exportExcel"
      >
      </avue-form>
    </el-dialog>
    <el-dialog
      title="出入对比图片"
      append-to-body
      :visible.sync="showOutInPic"
      @closed="closeOutInPicDialog"
      style="width: 2100px; height: 800px"
    >
      <el-row>
        <el-col span="11" offset="1">
          <el-row>
            <el-col offset="10"><span class="demonstration">入场图片</span></el-col>
          </el-row>
          <el-row>
            <el-image
              :src="dialog.inImage"
              style="width: 440px; height: 260px"
              :fit="fit"
            ></el-image>
          </el-row>
        </el-col>
        <el-col span="11" offset="1">
          <el-row>
            <el-col offset="10"><span class="demonstration">出场图片</span></el-col>
          </el-row>
          <el-row>
            <el-image
              :src="dialog.outImage"
              style="width: 440px; height: 260px"
              :fit="fit"
            ></el-image>
          </el-row>
        </el-col>
      </el-row>
      <el-row> </el-row>
      <!-- <el-row>
        <el-col offset="2"><span class="demonstration">入场图片</span></el-col>
        <el-col offset="4"><span class="demonstration">出场图片</span></el-col>
      </el-row>
      <el-row>
        <el-image :src="dialog.inImage" style="width: 400px; height: 300px" :fit="fit"></el-image>
        <el-image :src="dialog.outImage" style="width: 400px; height: 300px" :fit="fit"></el-image>
      </el-row>-->
      <!--<div class="demo-image__placeholder">
        <div class="block">
          <span class="demonstration">默认</span>
          <el-image :src="dialog.inImage" style="width: 400px; height: 300px" :fit="fit"></el-image>
        </div>
        <div class="block">
          <span class="demonstration">自定义</span>
          <el-image :src="dialog.outImage" style="width: 400px; height: 300px" :fit="fit">
            <div slot="placeholder" class="image-slot">
              加载中<span class="dot">...</span>
            </div>
          </el-image>
        </div>
      </div>-->
    </el-dialog>
    <exportExcel ref="exportExcel"></exportExcel>
    <carGroup ref="carGroup"></carGroup>
    <carDetails ref="carDetails"></carDetails>
  </basic-container>
</template>

<script>
import {
  getParkSpaceNode,
  getCarInList,
  getCarOutList,
  getRemainList,
  getMoneyStatistic,
  carOutByPersonOperation,
} from '@/api/v4ward/carv2/carinoutinfo';
import { getToken } from '@/util/auth';
import { mapGetters } from 'vuex';
import intoParkOption from './carinout-option_intoPark';
import outParkOption from './carinout-option_outPark';
import remainParkOption from './carinout-option_remainPark';
import exportExcel from './exportExcel';
import { getDictionary } from '@/api/common';
import carGroup from './car-group.vue';
import caret from './caret.vue';
import searchForm from './searchForm.vue';
import carDetails from './details.vue';
export default {
  components: { exportExcel, carGroup, caret, searchForm, carDetails },
  data() {
    return {
      upload: {},
      showUploadDialog: false,
      showSearch: true,
      sortType: null,
      activeName: 'intoPark',
      spacelist: [],
      exportExcelForm: {},
      showOutInPic: false,
      dialog: {
        inImage: '',
        outImage: '',
      },
      dateRange: [],
      payType: '',
      payTypeName: '',
      payTypeList: [],
      spaceId: '',
      shouldAccount: '',
      realityAccount: '',
      exportExcelFlag: false,
      showInImageBtn: true,
      showOutImageBtn: false,
      spaceParkTemp: '',
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      //导出条件弹框
      exportExcelOption: {
        align: 'center',
        addBtn: false,
        editBtn: false,
        delBtn: false,
        column: [
          {
            label: '车场名称',
            type: 'tree',
            prop: 'spaceId',
            search: true,
            width: 150,
            props: {
              label: 'title',
              value: 'key',
            },
            dicUrl: '/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode/v2?id=0',
            span: 12,
            rules: [
              {
                required: true,
                message: '请选择车场名称',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '车牌号',
            prop: 'carNo',
            span: 12,
          },
          {
            label: '入场时间',
            prop: 'inTime',
            span: 24,
            search: true,
            searchRange: true,
            display: true,
            type: 'datetimerange',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            rules: [
              {
                required: true,
                message: '请选择入场时间 ',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '出场时间',
            prop: 'outTime',
            span: 24,
            search: true,
            searchRange: true,
            display: false,
            type: 'datetimerange',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            rules: [
              {
                required: true,
                message: '请选择出场时间 ',
                trigger: 'blur',
              },
            ],
          },
        ],
      },
      option: {},
      ImportExcelOption: {
        submitBtn: false,
        emptyBtn: false,
        column: [
          {
            label: '数据上传',
            prop: 'excelFile',
            type: 'upload',
            drag: true,
            loadText: '数据上传中，请稍等',
            span: 24,
            propsHttp: {
              res: 'data',
            },
            tip: '请上传 .xls,.xlsx 标准格式文件',
            action: '/api/park/car/in/importCarRemain/v2',
          },

          {
            label: '模板下载',
            prop: 'downloadAction',
            formslot: true,
          },
        ],
      },
      intoParkOption: intoParkOption,
      outParkOption: outParkOption,
      remainParkOption: remainParkOption,
      data: [],
      img: '',
    };
  },
  watch: {
    activeName() {
      this.showInImageBtn = this.activeName === 'intoPark';
      this.showOutImageBtn = this.activeName === 'outPark';
    },
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        parkingSpaceGroup: this.vaildData(this.permission.parkingSpaceGroup, false),
        importCarRemain: this.vaildData(this.permission.import_car_remain, false),
        addBtn: false,
        viewBtn: false,
        delBtn: false,
        editBtn: false,
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // 通过 `vm` 访问组件实例
      vm.$refs.crud.$refs.table.doLayout();
    });
  },
  created() {
    this.initDefaultDateRange();
    this.initPayTypeList();
    this.option = this.intoParkOption;
    getParkSpaceNode().then((res) => {
      if (res.data.length > 0) {
        this.spacelist = res.data;
        this.spaceParkTemp = res.data[0];
        this.spaceId = res.data[0].id;
        this.onLoad();
      }
    });
    this.option.height = this.bodyHeight - 440;
  },
  methods: {
    openSearchBox() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.showSearch = !this.showSearch;
          if (this.activeName == 'outPark') {
            if (this.option.height == this.bodyHeight - 500) {
              this.option.height = this.bodyHeight - 330;
            } else {
              this.option.height = this.bodyHeight - 500;
            }
          } else {
            if (this.option.height == this.bodyHeight - 440) {
              this.option.height = this.bodyHeight - 330;
            } else {
              this.option.height = this.bodyHeight - 440;
            }
          }
          this.$refs.crud.getTableHeight();
        });
      });
    },
    sortChange(val) {
      let sortType = val.order;
      if (sortType == 'descending') {
        this.sortType = 1;
      } else if (sortType == 'ascending') {
        this.sortType = 2;
      } else {
        this.sortType = null;
      }
      this.onLoad();
    },
    importCarRemainForm() {
      this.showUploadDialog = true;
      setTimeout(() => {
        console.log(this.$refs.excelform);
        this.$refs.excelform.form.excelFile = [];
      });
    },
    exportDemoExcel() {
      this.$confirm('是否导出模板数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        //导出在场记录模版
        window.open(
          `/api/park/car/in/exportTemplateCarRemain/v2?${
            this.website.tokenHeader
          }=${getToken()}&spaceId=` + this.query.spaceId
        );
      });
    },
    uploadAfter(res, done) {
      done();
      if (this.vdui.isEmpty(String(res))) {
        this.$message.success('导入成功！');
        this.showUploadDialog = false;
        this.onLoad();
      }
    },
    manualOutPark(row) {
      this.$confirm(`车牌号【${row.carNo}】确定出场？`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return carOutByPersonOperation({ id: row.id, plateNumber: row.carNo });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    openCarGroup(row) {
      this.$refs.carGroup.openDialog(row);
    },
    showImage(e, imgUrl) {
      let innerHeight = window.innerHeight;
      let innerWidth = window.innerWidth;
      let clientX = e.clientX;
      let clientY = e.clientY;
      let pageX = e.pageX;
      let pageY = e.pageY;
      this.img = document.createElement('img');
      this.img.src = imgUrl;
      this.img.style.height = '400px';
      this.img.style.width = '600px';
      this.img.style.position = 'absolute';
      this.img.style.zIndex = 10000;
      if (clientX < innerWidth / 2) {
        this.img.style.left = clientX + 'px';
      } else {
        this.img.style.left = clientX - 600 + 'px';
      }
      if (clientY < innerHeight / 2) {
        this.img.style.top = clientY + 'px';
      } else {
        this.img.style.top = clientY - 400 + 'px';
      }
      document.body.appendChild(this.img);
    },
    hideImage() {
      document.body.removeChild(this.img);
    },
    closeOutInPicDialog() {
      this.showOutInPic = false;
    },
    handleInOutImageShow(row) {
      this.$refs.carDetails.openDialog(row, 'out');
      // if (this.vdui.isEmpty(row.cloudCarImage)) {
      //   this.$message.info('没有出场图片！');
      //   return;
      // }
      // this.dialog.outImage = row.cloudCarImage;
      // this.dialog.inImage = row.cloudCarInImage;
      // this.showOutInPic = true;
    },
    handleImageShow(row) {
      console.log(this.$refs);
      this.$refs.carDetails.openDialog(row, 'in');
      // var carImage = row.cloudCarImage;
      // if (this.vdui.isEmpty(carImage)) {
      //   this.$message.info('没有车辆图片！');
      //   return;
      // }
      // var images = [{ thumbUrl: row.cloudCarImage, url: row.cloudCarImage }];
      // this.$ImagePreview(images, 0);
    },
    onChangePayType(item) {
      if (item) {
        this.payTypeList.forEach((e) => {
          if (e.dictKey === item) {
            this.payTypeName = e.dictValue;
          }
        });
      } else {
        this.payTypeName = '';
        this.payType = '';
      }
      this.onLoad();
    },
    initPayTypeList: function () {
      getDictionary('tempcar_pay_type').then((data) => {
        this.payTypeList = data.data;
      });
    },
    initDefaultDateRange() {
      const date = new Date();
      let defaultStartDay = this.dayjs(date).format('YYYY-MM-DD 00:00:00');
      let defaultEndDay = this.dayjs(date).format('YYYY-MM-DD 23:59:59');
      this.dateRange = [defaultStartDay, defaultEndDay];
    },
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.initDefaultDateRange();
      this.query = {};
      this.spaceId = this.spaceParkTemp.id;
      this.onLoad(this.page);
    },
    searchChange(params, done) {
      this.query = params;
      this.query.inTimeS = this.dayjs(this.query.dateTime[0]).format('YYYY-MM-DD HH:mm:ss');
      this.query.inTimeE = this.dayjs(this.query.dateTime[1]).format('YYYY-MM-DD HH:mm:ss');
      this.query.outTimeS = this.dayjs(this.query.dateTime[0]).format('YYYY-MM-DD HH:mm:ss');
      this.query.outTimeE = this.dayjs(this.query.dateTime[1]).format('YYYY-MM-DD HH:mm:ss');
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    refreshChange() {
      this.onLoad(this.page, this.query);
    },
    onLoad(page) {
      if (!this.query.spaceId) {
        return;
      }
      this.loading = true;
      page = page || this.page;
      // this.query.payType = this.payType;
      // this.query.payTypeName = this.payTypeName;
      let values = {
        ...this.query,
      };

      //若tabPanType == "intoPark" 请求入场记录查询接口
      if (this.activeName == 'intoPark') {
        getCarInList(
          Object.assign({ current: page.currentPage, size: page.pageSize }, values)
        ).then(({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        });
      }
      //若tabPanType == 2 请求出场记录查询接口
      if (this.activeName == 'outPark') {
        getMoneyStatistic(
          Object.assign({ current: page.currentPage, size: page.pageSize }, values)
        ).then(({ data }) => {
          this.shouldAccount = data.shouldAccount;
          this.realityAccount = data.realityAccount;
        });
        getCarOutList(
          Object.assign({ current: page.currentPage, size: page.pageSize }, values)
        ).then(({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        });
      }
      //若tabPanType == 3 请求在场记录查询接口
      if (this.activeName == 'remainPark') {
        getRemainList(
          Object.assign(
            { current: page.currentPage, size: page.pageSize, orderType: this.sortType },
            values
          )
        ).then(({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        });
      }
    },
    handleSwitch() {
      //切换前清空前任列表数据
      this.data = [];
      this.page.currentPage = 1;
      if (this.activeName === 'intoPark') {
        this.option = this.intoParkOption;
        this.option.height = this.bodyHeight - 440;
        this.onLoad();
      } else if (this.activeName === 'outPark') {
        this.option = this.outParkOption;
        this.option.height = this.bodyHeight - 500;
        this.onLoad();
      } else if (this.activeName === 'remainPark') {
        this.option = this.remainParkOption;
        this.option.height = this.bodyHeight - 440;
        this.onLoad();
      }
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.crud.getTableHeight();
        });
      });
    },
    //打开导入弹框
    openExportExcel() {
      this.exportExcelForm.spaceId = '';
      this.exportExcelForm.inTime = '';
      this.exportExcelForm.carNo = '';
      this.exportExcelForm.outTime = '';
      const inTimeColumn = this.findObject(this.exportExcelOption.column, 'inTime');
      const outTimeColumn = this.findObject(this.exportExcelOption.column, 'outTime');
      if (this.activeName == 'outPark') {
        inTimeColumn.display = false;
        outTimeColumn.display = true;
      } else {
        inTimeColumn.display = true;
        outTimeColumn.display = false;
      }
      this.exportExcelFlag = true;
    },
    //按条件导出
    exportExcel(form, done) {
      var values = { ...form };
      const { inTime, outTime } = form;
      if (inTime) {
        values = { ...form, inTimeS: inTime[0], inTimeE: inTime[1] };
        values.inTime = null;
        this.form.inTime = null;
      }
      if (outTime) {
        values = { ...form, outTimeS: outTime[0], outTimeE: outTime[1] };
        values.outTime = null;
        this.form.outTime = null;
      }
      //入场记录导出
      if (this.activeName == 'intoPark') {
        this.$refs.exportExcel.intoExportExcel(values);
        done();
      }
      //出场记录导出
      if (this.activeName == 'outPark') {
        this.$refs.exportExcel.outExportExcel(values);
        done();
      }
      //在场记录导出
      if (this.activeName == 'remainPark') {
        this.$refs.exportExcel.remainExportExcel(values);
        done();
      }
    },
    exportExcelNew() {
      let form = this._.cloneDeep(this.query);
      var values = { ...form };
      const { inTime, outTime } = form;
      if (inTime) {
        values = { ...form, inTimeS: inTime[0], inTimeE: inTime[1] };
        values.inTime = null;
        this.form.inTime = null;
      }
      if (outTime) {
        values = { ...form, outTimeS: outTime[0], outTimeE: outTime[1] };
        values.outTime = null;
        this.form.outTime = null;
      }
      //入场记录导出
      if (this.activeName == 'intoPark') {
        this.$refs.exportExcel.intoExportExcel(values);
      }
      //出场记录导出
      if (this.activeName == 'outPark') {
        this.exportCarOutExcel(values);
      }
      //在场记录导出
      if (this.activeName == 'remainPark') {
        this.$refs.exportExcel.remainExportExcel(values);
      }
    },
    //导出出场记录
    exportCarOutExcel(values) {
      this.$confirm("确定导出所选条件下的数据吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let exportExcelFlag = 0;
        //车场id
        let spaceId = this.query.spaceId;
        //车牌号
        let carNo = '';
        if(values.carNo){
          carNo = values.carNo;
        }
        console.log('carNo>>>>>', carNo);
        //出场时间
        let outTimeS = values.outTimeS;
        let outTimeE = values.outTimeE;
        //车辆分类
        let carType = '';
        if(values.carType){
          carType = values.carType;
        }
        //车牌颜色
        let plateColor = '';
        if(values.plateColor){
          plateColor = values.plateColor;
        }
        //入场通道
        let inPassageId = '';
        if(values.inPassageId){
          inPassageId = values.inPassageId;
        }
        //出场通道
        let outPassageId = '';
        if(values.outPassageId){
          outPassageId = values.outPassageId;
        }
        //支付方式
        let payType = '';
        if(values.payType){
          payType = values.payType;
        }
        //操作类型
        let operate = '';
        if(values.operate){
          operate = values.operate;
        }
        window.open(
          `/api/v4ward/car/carOut/exportCarOut?${
            this.website.tokenHeader
          }=${getToken()}&exportExcelFlag=${exportExcelFlag}&spaceId=${spaceId}&carNo=${carNo}&outTimeS=${outTimeS}&outTimeE=${outTimeE}&carType=${carType}&plateColor=${plateColor}&inPassageId=${inPassageId}&outPassageId=${outPassageId}&payType=${payType}&operate=${operate}`
        );

      });
    },
  },
};
</script>

<style scoped>
.el-input.is-disabled .el-input__inner {
  color: red !important;
}
::v-deep .avue-form__menu--center {
  text-align: right;
  /* width: 100% !important; */
}
::v-deep .avue-crud__search .el-form-item--small.el-form-item {
  width: 100%;
}
</style>
<style>
#carinout2022 .avue-form__menu--center {
  text-align: right;
}
</style>
